module.exports = __webpack_public_path__ + "f68ff3289bbb6c02e983313e0a3e4773.png";